/* eslint-disable react/prop-types */
import React,
{
  Component,
  Fragment,
} from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import ds, { media } from 'designsystem';
import TagAGetTheApp from 'blocks/Navigation/Buttons/TagAGetTheApp';
import CloseButton from 'blocks/CloseButton';
import { Bind } from 'lodash-decorators';
import ANCHOR from 'common/consts/anchor';
import SplashScreen from 'blocks/SplashScreen';
import Logo from 'blocks/Navigation/Logo';
import Container from 'blocks/Container/Container';
import { Row, Column } from 'hedron';
import Header1 from 'elements/Header1';
import DescriptionText from 'elements/DescriptionText';

const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledHeader = styled(Header1)`
    font-size: ${ds.fs('l')};
    line-height: ${ds.get('type.lineHeight.l')};
    text-align: center;
    
    ${media.tablet`
      font-size: ${ds.fs('xl')};
      line-height: ${ds.get('type.lineHeight.xl')};
    `}
`;

const Description = styled(DescriptionText)`
    font-size: ${ds.fs('m')};
    line-height: ${ds.get('type.lineHeight.m')};
    text-align: center;

    ${media.tablet`
      font-size: ${ds.fs('l')};
      line-height: ${ds.get('type.lineHeight.l')};
    `}
`;

const BackButton = styled(TagAGetTheApp)`
  width: calc(${ds.get('metrics.m')} * 5);
`;

@inject('coreStore', 'appStore')
@observer
class NewsletterThankYouPage extends Component {
  state = {
    isShown: false,
    title: '',
    line1: '',
    line2: '',
  };

  static getDerivedStateFromProps(newProps) {
    const {
      confirmed,
      location,
      history,
      appStore: {
        currentLanguage,
      },
      coreStore: {
        newsletterThankYouPage: {
          successTitle,
          successLine1,
          successLine2,
          warningTitle,
          warningLine1,
          warningLine2,
          errorTitle,
          errorLine1,
          errorLine2,
          confirmedTitle,
          confirmedLine1,
          confirmedLine2,
        },
      },
    } = newProps;
    if (confirmed) {
      return {
        title: confirmedTitle,
        line1: confirmedLine1,
        line2: confirmedLine2,
      };
    }
    if (!location || !location.state || !location.state.code) {
      history.push(ANCHOR.HOME[currentLanguage]);
      return null;
    }
    switch (location.state.code) {
    case 200:
      return {
        title: successTitle,
        line1: successLine1,
        line2: successLine2,
      };
    case 1008:
      return {
        title: warningTitle,
        line1: warningLine1,
        line2: warningLine2,
      };
    default:
      return {
        title: errorTitle,
        line1: errorLine1,
        line2: errorLine2,
      };
    }
  }

  @Bind
  goBack(goHome) {
    const {
      history,
      appStore: {
        currentLanguage,
      },
    } = this.props;
    if (goHome) {
      history.push(ANCHOR.HOME[currentLanguage]);
    } else {
      history.goBack();
    }
  }

  render() {
    const {
      confirmed,
      coreStore: {
        initialCoreDataFetchDone,
        newsletterThankYouPage: {
          closeButtonText,
          backButtonText,
        },
      },
    } = this.props;

    if (!initialCoreDataFetchDone) {
      return <SplashScreen />;
    }

    const {
      isShown, title, line1, line2,
    } = this.state;

    return (
      <Fragment>
        <Container>
          <Row>
            <Column sm={10} smShift={1}>
              <CenteredContent>
                <Logo big />
              </CenteredContent>
            </Column>
            <Column sm={1}>
              {!confirmed && (
                <CloseButton
                  onClick={() => this.goBack(false)}
                  onMouseEnter={() => this.setState({ isShown: true })}
                  onMouseLeave={() => this.setState({ isShown: false })}
                  isShown={isShown}
                  text={closeButtonText}
                />
              )}
            </Column>
          </Row>
          <Row>
            <Column>
              <CenteredContent>
                <StyledHeader>
                  {title}
                </StyledHeader>
                <Description>
                  {line1}
                  <br />
                  {line2}
                </Description>
              </CenteredContent>
            </Column>
          </Row>
          <Row>
            <Column lg={6} lgShift={3}>
              <CenteredContent>
                <BackButton
                  onClick={() => this.goBack(true)}
                >
                  {backButtonText}
                </BackButton>
              </CenteredContent>
            </Column>
          </Row>
        </Container>
      </Fragment>
    );
  }
}
export default NewsletterThankYouPage;



// WEBPACK FOOTER //
// ./src/pages/NewsletterThankYouPage/index.jsx